<template>
  <!-- 顶部模块 -->
  <el-row class="header">
    <!-- 顶部灰底提示栏 -->
    <el-row class="header-top">
      <el-row class="header-title" style="font-size: 12px;">
        <el-col :span="16" style="text-align: left;">
          <span>{{CONFIG.servicePhone}}</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span>{{CONFIG.joinPhone}}</span>
        </el-col>

        <el-col :span="8" style="text-align: right;">
          <div class="login-info">
            <span>
              <a @click="toPURegister('company')" target="_blank" style="cursor: pointer;font-weight: 600;font-size: 14px;">采购单位加盟申请</a>
              &nbsp;&nbsp;
              <a @click="toSURegister" target="_blank" style="cursor: pointer;margin-left: 26px">供应商注册</a>
              &nbsp;&nbsp;
<!--              <a @click="toPURegister('user')" target="_blank" style="cursor: pointer;">采购用户注册</a>-->
            </span>
<!--            <a @mouseenter="isShow = !isShow" style="cursor: pointer;position: relative">-->
            <a class="loginA" @mouseenter="isShow = true" @mouseleave="isShow = false">
              <img class="loginImg" src="../assets/images/loginIcon.png" alt=""> 登录 <img class="arrowImg" src="../assets/images/arrow.png" alt="">
              <div v-show="isShow" class="transition-box" style="position: absolute;top: 30px;right: -20px" >
                <p><a @click="toSULogin" style="cursor: pointer;">供应商登录</a></p>
<!--                <p><a @click="toPULogin" style="cursor: pointer;">采购用户登录</a></p>-->
              </div>
            </a>
          </div>
        </el-col>
      </el-row>
    </el-row>

    <el-row class="header-info" >
      <el-col >
        <img src="@/assets/images/logo.png" style="width: 143px;height: 50px;cursor: pointer;vertical-align: middle;" @click="comeBack">
<!--        <span style="font-size: 20px;cursor: pointer;display:inline-block;vertical-align:middle;font-weight: bold" @click="comeBack">&nbsp;&nbsp;竞价采购网</span>-->
      </el-col>

<!--      <el-col style="display: flex;justify-content: flex-end">-->
<!--        <div class="search">-->
<!--          <el-select style="width: 120px" size="small" v-model="searchValue">-->
<!--            <el-option v-for="item in searchOptions" :key="item.label" :label="item.label" :value="item.label"></el-option>-->
<!--          </el-select>-->
<!--          <el-input v-model.trim="keyword" size="small" class="search-input" placeholder="请输入内容" clearable></el-input>-->
<!--        </div>-->
<!--        <button class="search-btn" @click="search()" style="cursor:pointer"><img class="search-img" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAG90lEQVR4XuWbd8iXVRTHv9+G0R5m2da2o6AFZntYpkWWLRpiEA0aQoOkMstQMCpo+EfbKIp20KA9QLOSpi3KooyiaO/dN75wfXm83uf5/Z7x89X3PfDDP957zzn38zzPveeecyR6ubCXrx8dByCpD4ANAWwA4AcAn5P8aWkB3ygASf0BjAAwCsAgABsBWDex2F8NAsBHAJ4D8ATJt7oDSm0AkvoBODssevsai/gawCMArif5cg09paZWBiBpdQDnAjgHwKqlrLYe/BCA80l+0HpovRGlAYRv+jQAkwD0rWe+cPa/AG4FMJnkF52yUwqApDUBPA1g5045lNDrjfNgkrM7YbNtAGGDex7ANi0cEQA7ezuANwB8H35eyCoA1g6/AQCOAjAGwMotdP4J4AiS3iMalbYASNoq7Nbe1fPEC7wKwEySn7XrpSTvH2MBnAdgaMG8/wCMJ2mwjUlLAJLWCE9yYI7VPwBcB+CyOue7JPtyHIBpADbJsWUIB5B8pikChQAkLQ/gKQD75Bh8FcDhJBc05VDYZKf4FMjR+SOAHUl+3ITNVgCuAXBmjqG7AYwj+VcTjsQ6JPltuAWAI8lYfDzuRPKXurZzAUjaE8ALOQamkryorvFW8yXtCsCve2qTdMB0aisdrf6eBBBefYemgxMK7iXp3XuJiCSfEg8Ai91bfNoMJfluHUfyAJweNrZY91wAe5D0sbTERNLFAC5NGHyB5N51HFkMgCSf076k+N+sODLbluT8OgarzpXkDXfHxPzDSDp0riQpAJMBXJLQNoPkGZWsNDBJ0vAQYMXa3iFZFD8UWk8BmJcISH4GsBlJR3XdJpIcCY5OODCQ5CdVHFsEgKRNAXyaUDSFpN+MbhVJQwC8nXDCN8fLqzgXA3A4mlI0mOR7VQw0PUfSO4nTaQ5JfyKlJQbgS0ysaAHJzUpr7tAESVMBXBCp95HYj+S3Zc3GABzVrRgpmU5yYlnFnRovyVdxH8exjCb5WFm7XQDCpcdxdixHkryvrOJOjQ+XJh/J8QZ+IsmZZe1mAWwJ4MOEguEk55RV3MnxkpwhcpY5K5U2wiyA3QDMSjg+gGTqZOjkGgt15wRFV5J0jrKUZAEcCiAVUfUh+XcprR0enBMP3E5yXFnTWQD7hXxfrKMvye/KKu7keEnPJnIUN5A8pazdLAAXMlI3K9+4fPYuNSLp/URustIVPQtgrZC8jBc6gqQzwUuNSHJpzXWJrEwg6QROKWknDphIcnoprR0cLMm5yVQ67FiSd5U1HQOw4jj5WfvOXdapovGSzgJwdWLMdiRT94RC8zEAp5yPj2Y46FiTpAua3S6SnnBmOHLka5LrVXEuBuCrZqr4MJak01LdKpJcWPGVPE6UVjoCvZgYgNPgrtLG2aDZJHfv1tUDkJSXqjuB5B1V/EslRG4EcFJC2UEkH69ipIk5oYLk+sM6kT5XpNavmp5PAXDtz/HAcpGheSTr1P9rcZDkpKiTo7HUStbkZYVdlh6fMDaN5IW1VlJhsqRhoUYRf/u+vvevk6rLA7BxOGvj3IDdP47knRXWUWmKJCdjXk/sS9ZX6+kvtglmPZR0Rej+iB33xcj7QWMFyjwyktxf9BKALRJjnJ4fRPKfSmTDpKLSmI+c13L6AWz0ZJL+VDoiIQH6qLPRCQNOgQ0j+Upd462KoybvJofVcgzNAOAY3MFSYyLpYAD3FDRO3EYytUeV9qEQgLVJyguOFhpz+OlsTOl8XOytpM0BOOl5dCLllR3uqvC+JFO5wVIQWgIIEPKqRVljzig7WzuLpBsZ2paw8AkA3HyV2nhTuhqB0BaAAMHOXQvA0WKROFR1U4XfCO8h80n+vnBCqDy7AOMih5sqRwLYum1aiw40hANJvlhxfrlWWUl7Abi/QnvcVwBcuvKu7uaoVhDj9ThV55Rd6oEZ7v5VIbT9BmSeoPt3/HQrFyRLPC03W7kL5XlJxwBwvJ+CVxlCaQDhc1gpRIru48lrniqxzuTQm8MJ03UNl3QYgHsLIIwyrDKGKwGIvmd3i7hXuInmSd9E/ZRvyuv8aAHBjRsjy0CoBSBLOqSqjgBwJIBd2nwKPi3eDD2IjiyfbCeyaxJCYwAiGI7edgj/T8DNlf65kvNNKL+70OL021ySvs6WlgDBwdIKicl+Ew4h6dOoUDoCoJXRpv4egjSfECkIvrO4YFoIYZkGEDZkR6qVISzzAOpC6BEAMhAezAml/Tm4m8y3y0WkxwAIEBxae5Gp+4Sv8GNiCD0KQJsQ/CZ0pf57HIA2IPzmDBPJLz22RwLIQHgYgMP2WLpS/D0WQIDgPmLXMmIIQxaG2j0aQAaCs9iORH0aTMpWu3s8gADBV+jt3ARO0m2/XdIrABSF3r0ewP/Rt0pfap6axgAAAABJRU5ErkJggg=="></button>-->
<!--      </el-col>-->
      <el-col style="display: flex;justify-content: flex-end;margin-left: 5px">
        <el-input placeholder="请输入内容" v-model.trim="keyword" class="input-with-select" style="width: 400px" clearable>
          <el-select v-model="searchValue" slot="prepend" placeholder="请选择">
            <el-option v-for="item in searchOptions" :key="item.label" :label="item.label" :value="item.label"></el-option>
          </el-select>
          <el-button @click="search()" slot="append" icon="el-icon-search" ></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!-- 导航栏 -->
    <el-menu :default-active="activedMenu($route.path)" class="el-menu-demo" mode="horizontal" @select="handleSelect" background-color="#1467b3" text-color="#fff" router>
      <template v-for="(item, index) in navs">
        <div class="part-line color-blue" v-if="index !== 0"></div>
        <el-menu-item :index="item.id" @click="reloadRouter(item,'/integration')">{{item.name}}</el-menu-item>
      </template>
    </el-menu>
<!--    <el-row class="nav-list">-->
<!--      <div v-for="(item, index) in navs" :key="index" class="nav-item" :class="activeIndex === index ? 'nav-active' : ''" @click="navItem(index)">-->
<!--        {{item.name}}-->
<!--      </div>-->
<!--    </el-row>-->
  </el-row>
</template>

<script>
  export default {
    name: 'Head',
    data () {
      return {
        activeIndex: 0,
        embedSrc:false,
        navs: [{
          name: '首页',
          id: '/index'
        }, {
          name: '产品服务',
          id: '/products'
        },
            {
            name: '竞价采购',
            id: '/Purchasing'
          },
        //   {
        //   name: '采购需求',
        //   id: '/purchase'
        // }, {
        //   name: '竞价结果',
        //   id: '/auction'
        // },
          {
          name: '竞价展场',
          id: '/mall'
        },
        //   {
        //   name: '电子招投标',
        //   id: '/jjsx'
        // },
          // {
          //   name: '采购管理',
          //   id: '/cg'
          // },
          // {
          //   name: '智能快采',
          //   id: '/kc'
          // },
          {
            name: '智能采购',
            id: '/integration'
          },
        //   {
        //   name: '招标信息',
        //   id: '/bidding'
        // },
          {
          name: '诚信公告',
          id: '/integrity'
        }, {
          name: '新闻资讯',
          id: '/news'
        },
          // {
          //   name: '全网检索',
          //   id: '/allSol'
          // },
          {
          name: '帮助中心',
          id: '/help'
        }, {
          name: '关于我们',
          id: '/about'
        }],

        isShow: false,
        // searchOptions: [{label: '采购需求'}, {label: '采购结果'},{label: '招投标'}],
        searchOptions: [{label: '采购需求'}, {label: '采购结果'},{label: '智能采购'}, {label: '采购终止'}],
        searchValue: '采购需求',

        keyword: '',
        SelList:{'purchase':'采购需求','integration':'智能采购',}
      // {'purchase':'采购需求','integration':'招投标'}
      }
    },
    mounted () {
      this.searchValue = (this.$route.name === 'purchase' ? '采购需求' : '采购结果')
      console.log('this.$route.name',this.$route.name)
      // this.searchValue = this.SelList[this.$route.name] || '竞价结果'
      console.log('this.searchValue',this.searchValue)
      /* 采购需求、竞价结果需要保存当前选项以及结果 */
      if (this.$route.query.keyword) {
        this.searchValue = this.$route.params.searchValue
        this.keyword = this.$route.query.keyword
      }
    },
    methods: {
      comeBack () {
        this.$router.push({name: 'index' })
      },
      toSULogin () {
        window.open(this.SSO_PAGE_URL + '/#/su/login', '_blank')
      },
      toPULogin () {
        window.open(this.SSO_PAGE_URL + '/#/pu/login', '_blank')
      },
      toSURegister () {
        window.open(this.SSO_PAGE_URL + '/#/su/register', '_blank')
      },
      toPURegister (val) {
        switch (val) {
          case 'user':
            window.open(this.SSO_PAGE_URL + '/#/pu/register', '_blank')
            break;
          case 'company':
            this.$router.push({name:'join'})
            break;
          default:
            break;
        }
      },
      search () {
        // this.searchValue = this.SelList[this.$route.name] || '竞价结果'
        if (this.searchValue === '采购需求') {
          if (this.$route.name === 'purchase') {
            this.$root.$emit('query',this.keyword)
          } else {
            this.$router.push({name: 'purchase', query: {keyword: this.keyword}, params: {value: this.searchValue}})
          }
        } else if (this.searchValue === '采购结果') {
          if (this.$route.name === 'auction') {
            this.$root.$emit('query',this.keyword)
          } else {
            this.$router.push({name: 'auction', query: {keyword: this.keyword}, params: {value: this.searchValue}})
          }
        } else if (this.searchValue === '采购终止') {
          if (this.$route.name === 'stop') {
            this.$root.$emit('query',this.keyword)
          } else {
            this.$router.push({name: 'stop', query: {keyword: this.keyword}, params: {value: this.searchValue}})
          }
        } else{
          if (this.$route.name === 'integration') {
            this.$root.$emit('query',this.keyword)
          } else {
            this.$router.push({name: 'integration', query: {keyword: this.keyword,ShowType:'all'}, params: {value: this.searchValue}})
          }
        }
      },
      handleSelect (key, keyPath) {
        // if (key === '/mall') {
        //   window.open(this.MALL_PAGE_URL, '_blank')
        // } else if (key === '/about') {
        //   window.open(this.HOME_ABOUT_PAGE_URL, '_blank')
        // }else if(key === '/jjsx'){
        //   window.open(this.HOME_JCX_URL5)
        // }

        switch (key) {
          case '/Purchasing':
            this.$router.push('Purchasing')
            break
          case '/mall':
            window.open(this.MALL_PAGE_URL, '_blank')
            break
          case '/about':
            // window.open('http://www.easyjcx.cn/index.php?id=57','_blank')
            // let src = 'http://oss.easyjcx.com/co-order/2020/03/16/4eb6afa88b0c4f30a394285f8fdb31524383381338212272911.pdf?Expires=316912805928&OSSAccessKeyId=LTAIbOsi2W8XJVoJ&Signature=isxJ3MFZx9KtoGIhQ5f3GXlAGgM%3D'
            // // let src =
            // this.embedSrc = true
            // window.open(src,'_blank')

            this.$router.push('about')
            // window.location.href(src)
            break
          // case '/integration':
          //     this.$router.push({name:'integration',query:{ShowType:'all'}})
          //   break
          case '/jjsx':
            // 电子招投标
            window.open('http://www.easyjcx.cn/index.php?id=73','_blank')
            break
          case '/cg':
            // 采购管理
            window.open('http://www.easyjcx.cn/index.php?id=57','_blank')
            break
          case '/kc':
            // 智能快采
            window.open('http://www.easyjcx.cn/index.php?id=259','_blank')
            break
          case '/allSol':
            this.$router.push('allSol')
            break
          default:
            // let name = this.$route.name
            // console.log('这里这里',name =='integration')
            // if(name =='integration' ){
            //   console.log('进来了')
            //   this.reloadRouter('/integration')
            // }
            break
        }
      },
      /* 根据路由决定菜单下划线 */
      activedMenu: function (val) {
        if (val.indexOf('/index') === 0) {
          return '/index'
        } else if (val.indexOf('/unit') === 0) {
          return '/index'
        } else if (val.indexOf('/supplier') === 0) {
          return '/index'
        } else if (val.indexOf('/purchase') === 0) {
          return '/purchase'
        } else if (val.indexOf('/auction') === 0) {
          return '/auction'
        } else if (val.indexOf('/mall') === 0) {
          return '/mall'
        } else if (val.indexOf('/bidding') === 0) {
          return '/bidding'
        } else if (val.indexOf('/integrity') === 0) {
          return '/integrity'
        } else if (val.indexOf('/news') === 0) {
          return '/news'
        } else if (val.indexOf('/help') === 0) {
            return '/help'
        } else if (val.indexOf('/about') === 0) {
          return '/about'
        }else if (val.indexOf('/allSol') === 0) {
          return '/allSol'
        }else if (val.indexOf('/products') === 0) {
          return '/products'
        }
      },
      reloadRouter(item,path) {
        // console.log('name',name)
        if(item.id == path){
          // console.log('这里')
          this.$router.push({
            path: "/redirect",
            query: {
              nextPath: path
            }
          });
        }

      },
      navItem(index) {
        this.activeIndex = index
      }
    }
  }
</script>

<style scoped lang="less">
  .header {
    width: 100%;
  }

  .header-top {
    background: #F8F8F8;
    height: 40px;
    color: #666;
  }

  .header-top .header-title{
    min-width: 1200px;
    max-width: 1200px;
    margin: 14px auto;
    display: flex;
    justify-content: space-between;
  }

  .header-title .login-info > span {
    color: #1467b3;
    margin-right: 20px;
  }

  .header-title .login-info > a {
    padding: 10px;
    font-size: 12px;
    color: #1467b3;
  }

  .header-info {
    min-width: 1215px;
    max-width: 1215px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0 15px 0;
    margin: 0 auto;
  }

  /*搜索框*/
  .search {
    height: 32px;
    border: 1px solid #188bd6;
  }

  .search-input {
    width: 200px;
  }

  .search-btn {
    width: 80px;
    background-color: #1467b3;
    border: none;
    border-radius: 0px;
  }

  .search-img {
    width: 15px;
    height: auto;
    margin: 0 auto;
  }



  .part-line {
    height: 60%;
    border-left: 1px solid white;
  }

  .color-blue {
    height: 50%;
    border-color: #7ecef4;
  }


  /* 登录框过渡效果 */
  .header-top .transition-box {
    background-color: #fff;
    border: 1px solid #e4e7ed;
    color: #666666;
    width: 90px;
    height: 30px;
    text-align: center;
    z-index: 1500;
    box-sizing: border-box;
    position: absolute;
    transition: all 0.5s ease-in;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

  }
  .header-top .transition-box>p {
    font-size: 12px;
    padding: 10px 0;
    transform: translateZ(0);
  }
  .header-top .transition-box>p:hover {
    color: #1467b3!important;
  }
  .loginImg {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 5px;
    left: -12px;
  }
  .arrowImg {
    width: 17px;
    height: 18px;
    position: absolute;
    top: 7px;
    left: 36px;
    -webkit-transition:-webkit-transform .2s ease-in;
    -webkit-backface-visibility:hidden;
    -moz-transition:-moz-transform .2s ease-in;
    -o-transition:-o-transform .2s ease-in;
    transition:transform .2s ease-in;
  }
  .loginA {
    cursor: pointer;
    position: relative;
    margin-left: 10px;
    color: #1467b3;
  }
  .loginA:hover {
    .arrowImg {
      transform:rotate(180deg);
    }

  }
  .nav-list {
    display: flex;
    width: 1200px;
    margin: 20px auto 2px;
    justify-content: space-between;
  }
  .nav-item {
    font-size: 16px;
    cursor: pointer;
  }
  .nav-item:hover {
    color: rgb(49, 66, 227);
    border-bottom: 4px solid rgb(49, 66, 227);
    font-weight: bold;
  }
  .nav-active {
    font-weight: bold;
    color: rgb(49, 66, 227);
    border-bottom: 4px solid rgb(49, 66, 227);
    padding-bottom: 10px;
  }
</style>
<style>
  .el-menu.el-menu--horizontal {
    border-bottom-width: 0px!important;
  }

  .header .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,.header .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    color: #fff;
  }

  /*菜单被选中*/
  .header .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #7ecef4;
    color: #fff;
  }

  .header .el-menu-demo > .el-menu-item {
    margin: 0 0.5%;
    /*margin: 0 0%;*/
  }

  .header .el-menu {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header .el-menu > .el-menu-item {
    height: 40px;
    line-height: 35px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /*.header .el-select {*/
  /*  border-right: 1px solid #188bd6 ! important;*/
  /*}*/

  .header .el-input__inner {
    /*border: none ! important;*/
    /*padding-left: 25px;*/
    /*border-radius: 0px;*/
  }

  /*.el-select-dropdown__item.selected {*/
  /*  color: #606266!important;*/
  /*  font-weight: normal!important;*/
  /*  transform: translateZ(0);*/
  /*}*/

  /*.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {*/
  /*  color: #1467b3!important;*/
  /*  background-color: #fff;*/
  /*}*/
  .el-select .el-input {
    width: 104px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/head.vue